import { render, staticRenderFns } from "./ContactDistributionsByOwner.vue?vue&type=template&id=ae20031a&scoped=true"
import script from "./ContactDistributionsByOwner.vue?vue&type=script&lang=js"
export * from "./ContactDistributionsByOwner.vue?vue&type=script&lang=js"
import style0 from "./ContactDistributionsByOwner.vue?vue&type=style&index=0&id=ae20031a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ae20031a",
  null
  
)

export default component.exports